export interface LocationBoxColors {
  background: string;
  border: string;
  text: string;
}

export const LOCATION_BOX_PALETTE: readonly LocationBoxColors[] = [
  {
    background: "rgb(240 246 255 / 0.94)",
    border: "rgb(91 124 184)",
    text: "rgb(18 32 56)",
  },
  {
    background: "rgb(255 248 235 / 0.94)",
    border: "rgb(196 142 56)",
    text: "rgb(56 38 12)",
  },
  {
    background: "rgb(232 250 242 / 0.94)",
    border: "rgb(72 158 120)",
    text: "rgb(16 48 36)",
  },
  {
    background: "rgb(248 238 255 / 0.94)",
    border: "rgb(148 98 196)",
    text: "rgb(40 22 58)",
  },
  {
    background: "rgb(255 241 245 / 0.94)",
    border: "rgb(196 98 128)",
    text: "rgb(58 18 32)",
  },
  {
    background: "rgb(235 250 255 / 0.94)",
    border: "rgb(72 148 176)",
    text: "rgb(14 40 52)",
  },
];

export function locationBoxColors(index: number): LocationBoxColors {
  return LOCATION_BOX_PALETTE[index % LOCATION_BOX_PALETTE.length];
}

/** Palette slot for a mounted run. A place keeps one color across visits and chapters. */
export function locationColorIndex(
  runs: readonly { locationLabel: string }[],
  index: number,
): number {
  const places = runs.map((run) => run.locationLabel);
  return new Set(places.slice(0, places.indexOf(places[index] ?? ""))).size;
}
